import { Component,OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { MdDialog,MdDialogRef } from '@angular/material';
import { HttpService } from '../../shared/services/http.service'
import { LayoutService } from '../../layout/layout.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { Subject }    from 'rxjs/Subject';
import { TranslateService } from 'ng2-translate';


// Dialog box for add and edit maintenance tables entity
// openDialog
@Component({
    selector: 'edit-address',
    template: require('./deleteAddress.component.html'),
    styles: [require('./deleteAddress.component.scss'),require('../../style.scss')],
    providers: [HttpService,SessionHandler]
})
export class deleteAddressComponent implements OnInit {
	addressChange:Subject<string>= new Subject<string>();
    table:any;
    rowData:any = {}; 
    addressData:any;
    isAdd:boolean = false;
    isConfirm:boolean = false;
    id:any;
    msg:any;
    errorMsg:any;
    successMsg:any;
    showInfo:boolean = false;
    userData:any;
    loader:boolean=false;
    showAddressList:boolean = false;
    isAdmin:boolean = false;
    tradePartnerId:any;
    invoiceAddress:any;
    constructor(private router: Router,private http:HttpService,private commonService:CommonService,private translate: TranslateService,private sessionHandler:SessionHandler,
        private dialog: MdDialog,public dialogRef: MdDialogRef<deleteAddressComponent>) {
                   this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
        }

    ngOnInit():void {
        if(this.rowData && Object.keys(this.rowData).length > 0 ) {
            if(this.rowData.table == 'address') {
                this.isAdd = true;
                this.addressData = [];
                for(let i in this.rowData.data) {
                    if(this.rowData.data[i].manual==true){
                        this.addressData.push(this.rowData.data[i]);
                    }
                }
                if(this.addressData.length > 0){
                    this.showAddressList = true;
                }
            }
        }
    }
    public confirmDeactivate(table,id) {
        this.isConfirm = true;
        this.showInfo = false;
        if(table == 'address') {
            this.msg = 'confirmation_delete_address';
        }
        this.id = id;
        this.table = table;
    }

    public closeDialog(){
        this.showInfo = false;
        this.showAddressList = true;
        this.isConfirm = false;
        // this.dialogRef.close();
    }

    public deactivate(table,id){
        if(table == 'address') {
            let data = {};
            data['addressId'] = id;
            this.loader = true;
            this.http.postRequest(data,'address/v1/delete').subscribe(
                res => {
                    this.updateResponse(res);
                },
                err => {
                    this.showInfo = true;
                    this.loader = false;
                    this.errorMsg = err;
                    this.http.onEnd();
                }
            );
        }
    }

    public updateResponse(res) {
        this.showInfo = true;
        if(res.status =='Success'){
            this.successMsg = 'address_delete_success';
            this.getAddressList();
        }
        if(res.status == 'Failed') {
            this.errorMsg = res.errorMessage;
        }
        this.loader = false;
        this.http.onEnd();
    }
    
    public getAddressList() {
        this.http.getRequest('address/v1/getAddress?tradePartnerId='+ this.tradePartnerId)
            .subscribe(
            res => {this.saveAddressList(res)},
            err => {
                this.showInfo = true;
                this.errorMsg = err;
                this.loader = false;
                this.http.onEnd();
        });
    }

    public saveAddressList(res) {
        this.addressData = [];
        for(let i in res.items) {
            if(res.items[i].manual==true){
                this.addressData.push(res.items[i]);
            }
        }
        this.http.onEnd();
        this.commonService.changeAddressData();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trade/details/deleteAddress.component.ts